function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
var Currency = /*#__PURE__*/function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
      key: "formatMoney",
      value:
      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }
    }]);

    return Currency;
  }();

$(document).ready(function(){
 
    $('.size_options_wrp input').change(function(){
            // $( this ).val();
           var jsonVal=  JSON.parse($( this ).attr('data-vjson'));
            var valueId = $( this ).attr('data-vid');
     
            if(valueId){
                $(this).closest('.ProductItem__Info').find('.addtocart_collection input[name="id"]').val(valueId);
            }
            
            if(jsonVal.featured_image){
                var featuredImg = jsonVal.featured_image.src;
                $(this).closest('.ProductItem__Wrapper').find('.ProductItem__ImageWrapper img').attr('srcset',featuredImg);
            }

            var priceOption = jsonVal.price;
            var cPriceOption = jsonVal.compare_at_price;

            var productMetaPrices = $(this).closest('.ProductItem__Info').find('.ProductItem__PriceList');
            var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
            productMetaPrices.html('');

            if(productMetaPrices &&  (cPriceOption > priceOption) ){

                productMetaPrices.append("<span class=\"ProductItem__Price Price Price--highlight Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(priceOption, currencyFormat), "</span>"));
                productMetaPrices.append("<span class=\"ProductItem__Price Price Price--compareAt Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(cPriceOption, currencyFormat), "</span>"));
          
                var discountPercentage = calculateDiscountPercentage(priceOption, cPriceOption);
                function calculateDiscountPercentage(price, compareAtPrice) {

                    if (compareAtPrice && compareAtPrice > price) {
                    var discount = ((compareAtPrice - price) / compareAtPrice) * 100;
                    return discount.toFixed(2);
                    } else {
                    return 0;
                    }
                }
                // console.log(discountPercentage);
                if(discountPercentage){
                    productMetaPrices.append("<span class=\"ProductItem__Price Price Price--discount_rate Text--subdued u-h4\" style=\"margin-left: 15px;\" data-money-convertible>" + Math.floor(discountPercentage) + "%OFF</span>");
                }
            }else{
                productMetaPrices.append("<span class=\"ProductItem__Price Price Price--highlight Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(priceOption, currencyFormat), "</span>"));
            }   
           
        });
});


$('div.search_suggestion').hide();
$('.Search__Input').on('blur', function() {
    $('div.search_suggestion').fadeOut('medium');
});
$('.Search__Input').on('focus', function() {
    var value = $(this).val();
    if ( value.length > 0 ){
      $('div.search_suggestion').hide('medium');
    }else{
      $('div.search_suggestion').show();
    }
});
$('.Search__Input').on('change keyup paste', function() {
  // console.log($(this).val().length);
  if($(this).val().length > 0) {
    $('div.search_suggestion').hide('medium');
  }else{
    $('div.search_suggestion').show();
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const continueButton = document.querySelector(".continue_shop");

  if (continueButton) {
    continueButton.addEventListener("click", (e) => {
      e.preventDefault();  // Prevents the default anchor behavior
      window.location.href = "https://maharishi-ayurveda-in.myshopify.com/checkout";  // Redirects to checkout
    });
  }
});
// document.querySelector('.ayurdent-banners .desktop').addEventListener('click', function() {
//     window.scrollTo({
//         top: 1300, // Adjust this value based on where you want to scroll
//         behavior: 'smooth' // Enables smooth scrolling
//     });
// });

// document.querySelector('.ayurdent-banners .mobile').addEventListener('click', function() {
//     window.scrollTo({
//         top: 1300, // Adjust this value based on where you want to scroll
//         behavior: 'smooth' // Enables smooth scrolling
//     });
// });
